import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from "react-intl";

import StatCard from "components/dashboard/StatCard";
import Badge from "components/Badge";
import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import {UserAgentUtils} from "utils/useragent";

MissedTurnoverCard.propTypes = {
    value: PropTypes.number,
    currency: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    hasSyliusStockAlertFeature: PropTypes.bool,
};

function MissedTurnoverCard({value, currency, loading, hasSyliusStockAlertFeature = false, ...props}) {
    const intl = useIntl();

    const MissedTurnoverValue = hasSyliusStockAlertFeature ? value !== null ? (
        <FormattedNumberWithCurrency
            value={value}
            currency={currency}
        />
    ) : "—" : 'N/A';

    return (
        <StatCard
            label={<FormattedMessage id="dashboard.card.title.caManque" />}
            value={MissedTurnoverValue}
            tag={
                <Badge
                    color="warning"
                    size={'large'}
                    indicator={'circle'}
                    isBold={false}
                    labelSize={14}
                    border={true}
                >
                    <FormattedMessage id="dashboard.card.tag.restocking" />
                </Badge>
            }
            loading={loading}
            tooltip={intl.formatMessage({ id: hasSyliusStockAlertFeature ? "dashboard.tooltip.caManque" : "dashboard.tooltip.caManque.disabled" })}
            tagBelow={UserAgentUtils.isMobile()}
        />
    );
}

export default MissedTurnoverCard;
